"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InstagramSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function InstagramSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Instagram"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "instagram-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Instagram-square-2",
    "data-name": "Instagram-square"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.428,92.5H18.571A11.084,11.084,0,0,1,7.5,81.429V18.571A11.084,11.084,0,0,1,18.572,7.5H81.429A11.084,11.084,0,0,1,92.5,18.571V81.429A11.084,11.084,0,0,1,81.428,92.5Zm-62.856-80A6.079,6.079,0,0,0,12.5,18.571V81.429A6.079,6.079,0,0,0,18.571,87.5H81.428A6.079,6.079,0,0,0,87.5,81.429V18.571A6.079,6.079,0,0,0,81.429,12.5Z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.005,39.092A10.908,10.908,0,1,0,60.912,50,10.891,10.891,0,0,0,50.005,39.092Zm0,18A7.091,7.091,0,1,1,57.1,50a7.1,7.1,0,0,1-7.091,7.091ZM63.9,38.646A2.545,2.545,0,1,1,61.359,36.1,2.538,2.538,0,0,1,63.9,38.646Zm7.224,2.582c-.161-3.408-.94-6.427-3.436-8.914s-5.507-3.265-8.914-3.436c-3.513-.2-14.041-.2-17.553,0-3.4.161-6.418.94-8.914,3.427s-3.266,5.506-3.437,8.914c-.2,3.512-.2,14.04,0,17.553.161,3.408.94,6.427,3.437,8.914s5.506,3.265,8.914,3.436c3.512.2,14.04.2,17.553,0,3.407-.161,6.426-.94,8.914-3.436s3.265-5.506,3.436-8.914c.2-3.513.2-14.031,0-17.544ZM66.589,62.541a7.18,7.18,0,0,1-4.044,4.044c-2.8,1.11-9.445.854-12.54.854s-9.75.247-12.541-.854a7.183,7.183,0,0,1-4.044-4.044c-1.11-2.8-.854-9.446-.854-12.541s-.247-9.749.854-12.54a7.177,7.177,0,0,1,4.044-4.044c2.8-1.111,9.446-.855,12.541-.855s9.749-.247,12.54.855a7.174,7.174,0,0,1,4.044,4.044c1.111,2.8.855,9.445.855,12.54S67.7,59.749,66.589,62.541Z"
  })))));
}